export { useTemplateResolver, resolveTemplate } from './useTemplateResolver'
